import { StateCreator } from 'zustand';
// Types
import { ChatSlice, ChatState } from './types';

const initialChatState: ChatState = {
  chatMessages: [],
  chatStage: 'new',
  isChatLoading: false,
  isFetched: false,
  isChatInitialized: false,
  shouldResetChat: false,
  currentContextId: '',

  // Human-in-the-loop state
  isWaitingForUserResponse: false,
  isConfirmationAction: false,

  // Chat input state
  inputValue: '',
  previewUrl: '',
  base64IMG: '',
  textareaCursorPosition: 0,
  textareaScrollTop: 0,

  // Rich Text Editor persistence
  richTextEditorValues: {},

  // Suggestion panel
  isSuggestionOpen: false,
  hasSuggestionAnimated: false,
};

export const createChatSlice: StateCreator<ChatSlice, [], [], ChatSlice> = (
  set,
  _,
) => ({
  ...initialChatState,
  // Chat actions
  setChatMessages: (chatMessages) => set({ chatMessages }),
  setChatLoading: (isChatLoading) => set({ isChatLoading }),
  setChatInitialized: (isChatInitialized) => set({ isChatInitialized }),
  setChatResetFlag: (shouldResetChat: boolean) => set({ shouldResetChat }),
  setCurrentContextId: (currentContextId) => set({ currentContextId }),
  setChatStage: (chatStage) => set({ chatStage }),
  setFetched: (isFetched) => set({ isFetched }),
  resetChat: () => set(initialChatState),

  // Human-in-the-loop actions
  setIsWaitingForUserResponse: (isWaitingForUserResponse) =>
    set({ isWaitingForUserResponse }),
  setIsConfirmationAction: (isConfirmationAction) =>
    set({ isConfirmationAction }),

  // Chat input actions
  setInputValue: (inputValue) => set({ inputValue }),
  setPreviewUrl: (previewUrl) => set({ previewUrl }),
  setBase64IMG: (base64IMG) => set({ base64IMG }),
  setTextareaCursorPosition: (textareaCursorPosition) =>
    set({ textareaCursorPosition }),
  setTextareaScrollTop: (textareaScrollTop) => set({ textareaScrollTop }),
  resetChatInput: () =>
    set({
      inputValue: '',
      previewUrl: '',
      base64IMG: '',
      textareaCursorPosition: 0,
      textareaScrollTop: 0,
    }),

  // Rich Text Editor actions
  setRichTextEditorValue: (key, value) =>
    set((state) => ({
      richTextEditorValues: {
        ...state.richTextEditorValues,
        [key]: value,
      },
    })),
  clearRichTextEditorValue: (key) =>
    set((state) => {
      const { [key]: _, ...rest } = state.richTextEditorValues;
      return { richTextEditorValues: rest };
    }),
  clearAllRichTextEditorValues: () => set({ richTextEditorValues: {} }),

  // Suggestion panel actions
  setIsSuggestionOpen: (isSuggestionOpen) => set({ isSuggestionOpen }),
  setHasSuggestionAnimated: (hasSuggestionAnimated) =>
    set({ hasSuggestionAnimated }),
  resetSuggestionPanel: () =>
    set({ isSuggestionOpen: false, hasSuggestionAnimated: false }),
});
